import { Box } from "@mui/material";

// Shared page-shell metrics so every page (and the top bar) lines up the same way.
// --app-chrome-height is kept up to date by layout/index.js (top bar + impersonation banner).
export const PAGE_PADDING = { xs: 1.5, md: 2 };
export const PAGE_GAP = 2;
export const PAGE_MIN_HEIGHT = "calc(100vh - var(--app-chrome-height, 56px))";

const ParentWrapper = ({ children, sx }) => {
  return (
    <Box
      sx={{
        p: PAGE_PADDING,
        ...sx,
        transition: (theme) =>
          theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.shortest,
          }),
        backgroundColor: "#FEFEFE",
        // Fill the space under the top bar exactly — padding is included so a short page
        // doesn't get a page-level scrollbar.
        minHeight: PAGE_MIN_HEIGHT,
        boxSizing: "border-box",
        minWidth: 0,
        gap: sx?.gap ?? PAGE_GAP,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
    </Box>
  );
};

export default ParentWrapper;
